import { AppConfig } from "@/core/models/app-config";

const config: AppConfig = {
  // apiUrl: "https://car-service-server-mvlg.onrender.com",
  apiUrl: import.meta.env.VITE_API_URL as string,
  appUrl: process.env.VITE_APP_URL as string,
  appName: process.env.VITE_APP_NAME as string,
};

export default config;
